import { formatDate, formatDateTime } from "../utils/SaitUtils";

/*
	Obbligatori:
		headerName
		field
	Facoltativi:
		width
*/

export default function SaitDateColumn(config) {
	return {
		valueFormatter: (value, row, column, apiRef) => (config.time ? formatDateTime(value) : formatDate(value)),
		headerName: config.headerName,
		width: config.width || (config.time ? 120 : 90),
		field: config.field,
		hidden: config.hidden || false,
		sortable: config.sortable !== null && config.sortable !== undefined ? config.sortable : true,
		type: config.type || (config.time ? "dateTime" : "date"),
		flex: config.flex,
		objmod: config.objmod,
	};
}
